import { SET_VEHICLE_INFO } from '../actions/types';

export default function vehicle(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_VEHICLE_INFO:
				return {
					...state,
					...action.payload
				};

			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/vehicle.js